/**
 * Theme utility functions for handling light/dark mode
 */

// Check if the user's system prefers dark mode
export function prefersDarkMode(): boolean {
  return (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
}

// Listen for changes in color scheme preference
export function addColorSchemeListener(
  callback: (isDarkMode: boolean) => void
): () => void {
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  const handleChange = (e: MediaQueryListEvent) => {
    callback(e.matches);
  };

  // Modern API
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }
  // Legacy API for older browsers
  else {
    mediaQuery.addListener(handleChange as any);
    return () => mediaQuery.removeListener(handleChange as any);
  }
}

// Get the appropriate asset based on color scheme
export function getThemeAwareAsset<T>(lightAsset: T, darkAsset: T): T {
  return prefersDarkMode() ? darkAsset : lightAsset;
}
